// import not working
// const Crafty1 = require('craftyjs');
const maxNumberOfDashes = 5;
let numberOfDashes = 0;
document.addEventListener("keydown", function(event) {
    if (event.keyCode === 32) {
        player.jump();
    }
    /*
    if (event.keyCode === 16) {
        if (numberOfDashes < maxNumberOfDashes) {
            const dashSize = 1600;
            
            player.velocity().x = player.velocity().x > 0 ? dashSize : -dashSize;
            setTimeout(() => {
                player.velocity().x = 200;
            }, 200);
            numberOfDashes++;
        }
    }
    */
});

import "./main.scss";
import snoeffelImage from "./assets/snoeffel.png";

import isMobileDevice from "./helper";
const shortid = require("shortid");
import { scaleLinear } from "d3-scale";

var database = firebase.database();
const startButton = document.querySelector("button");
function setHighscore(userId, name, points) {
    return firebase
        .database()
        .ref("high-scores/" + userId)
        .set({
            name,
            points
        });
}
const scoreBoard = document.querySelector(".finish-screen .score-board");
function generateScoreBoard() {
    scoreBoard.innerHTML = "";
    firebase
        .database()
        .ref("high-scores")
        .orderByChild("points")
        .limitToLast(3)
        .once("value")
        .then(function(snapshot) {
            let index = 0;

            const highscores = [];
            snapshot.forEach(function(child) {
                highscores.push(child.val());
            });

            highscores.reverse();
            highscores.forEach(function({ name, points }) {
                const li = document.createElement("li");
                li.innerHTML = `<div>${index +
                    1}. ${name}</div><div>${points}</div>`;
                scoreBoard.appendChild(li);
                index++;
            });
        });
}
generateScoreBoard();

const screenWidth = Math.max(
    document.documentElement.clientWidth,
    window.innerWidth || 0
);
const screenHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
);

const movementScale = scaleLinear()
    .domain([5, -5])
    .range([0, screenWidth]);

const startScreenh2 = document.querySelector(".start-screen h2");
if (isMobileDevice()) {
    startScreenh2.innerHTML = `${
        startScreenh2.innerHTML
    } <strong>Tap for at hoppe, tilt for bevægelse</strong>`;
}

Crafty.init(screenWidth, screenHeight, document.getElementById("game"));

const tryAgainButton = document.querySelector(
    ".finish-screen button.try-again"
);

const startScreen = document.querySelector(".start-screen");

startButton.addEventListener("click", () => {
    Crafty.enterScene("Level1");
    startScreen.classList.add("hidden");
    startTimer();
});

let pointsCounter = 0;
const counterSpan = document.querySelector("span.counter");
const timerSpan = document.querySelector("span.timer");
const timeLeftSpan = document.querySelector("span.timer > span.time-left");

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const levelWidth = 1600;

let currentXPosition = 0;
let positions = [];

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
let supportsDeviceMotion = false;

if (isMobileDevice()) {
    if (window.DeviceMotionEvent) {
        window.addEventListener(
            "devicemotion",
            event => {
                supportsDeviceMotion = true;
                positions.push(event.accelerationIncludingGravity.x);
            },
            false
        );
    } else {
    }
}

setTimeout(() => {
    if (!supportsDeviceMotion && isMobileDevice()) {
        startButton.classList.add("hidden");
        if (isSafari) {
            document
                .querySelector(".start-screen p.activate.safari")
                .classList.add("visible");
        } else {
            document
                .querySelector(".start-screen p.activate")
                .classList.add("visible");
        }
    }
}, 500);

let player;
const playerWidth = 30;
Crafty.defineScene("Level1", function() {
    const floorHeight = 10;
    Crafty.e("Floor, 2D, Canvas, Solid, Color, Collision")
        .attr({ x: 0, y: screenHeight, w: levelWidth, h: 10 })
        .color("white");

    player = Crafty.e(
        "Player, 2D, Canvas, Color, Motion, Solid, Twoway, Gravity, Collision"
    )
        .attr({ x: 20, y: 0, w: 30, h: 30 })
        .color("white")
        .twoway(200, 400)
        .gravity("Floor")
        .checkHits("Floor")
        .bind("EnterFrame", function(e) {
            if (isMobileDevice()) {
                const total = positions.reduce((acc, current) => acc + current);
                const avg = total / positions.length;
                const newPosition = movementScale(avg);
                if (newPosition > 0 && newPosition < screenWidth - 5) {
                    this.x = newPosition;
                }

                const numberOfElementsToAverage = 15;
                if (positions.length > numberOfElementsToAverage) {
                    positions.splice(
                        0,
                        positions.length - numberOfElementsToAverage
                    );
                }
            }
        });

    window.addEventListener("touchstart", () => player.jump());
});

function getRandomSnoeffelSize() {
    const randomWidth = 24;
    return {
        width: randomWidth,
        height: randomWidth * 2.3
    };
}

let isGameOver = false;
function drop() {
    const randomSnoeffelSize = getRandomSnoeffelSize();
    const randomx = Math.floor(Math.random() * screenWidth);
    Crafty.e("Drop, 2D, Canvas, Color, Solid, Gravity, Collision, Image")
        .attr({
            x: randomx,
            y: 0,
            w: randomSnoeffelSize.width,
            h: randomSnoeffelSize.height
        })
        .color("#" + Math.floor(Math.random() * 16777215).toString(16))
        .image(snoeffelImage, "repeat")
        .gravity()
        .checkHits("Player")
        .bind("HitOn", function() {
            this.destroy();

            if (!isGameOver) {
                pointsCounter++;
                counterSpan.innerHTML = pointsCounter;
            }
            counterSpan.classList.add("highlight");
            setTimeout(() => {
                counterSpan.classList.remove("highlight");
            }, 50);
        })
        .bind("EnterFrame", function() {
            if (this.y > screenHeight) this.destroy();
        });
}

const submit = document.querySelector(".finish-screen button.submit");
const nameInput = document.querySelector(".finish-screen input");

submit.addEventListener("click", () => {
    submit.innerHTML = "Sender score";
    setHighscore(shortid.generate(), nameInput.value, pointsCounter).then(
        () => {
            submit.innerHTML = "Score sendt 👍";
            submit.disabled = true;
            generateScoreBoard();
        }
    );
});

let secondsLeft = 59;
const gameDuration = 60;
let setCountdownInterval;
function startTimer() {
    timerSpan.classList.add("visible");
    startButton.classList.add("hidden");

    setTimeout(() => {
        isGameOver = true;

        showFinishScreen();
    }, 1000 * gameDuration);

    setCountdownInterval = setInterval(() => {
        if (!isGameOver) {
            secondsLeft--;
            timeLeftSpan.innerHTML = secondsLeft;
        }
    }, 1000);
}

function showFinishScreen() {
    document.querySelector(".finish-screen").classList.add("visible");
    document.querySelector(
        ".finish-screen h2"
    ).innerHTML = `Fedt, du fik <strong>${pointsCounter} Snøfler</strong> på <strong>1 minut!</strong>`;
    tryAgainButton.addEventListener("click", restartGame);
}

function restartGame() {
    numberOfDashes = 0;
    submit.disabled = false;
    submit.innerHTML = "Save score!";
    secondsLeft = 59;
    player.attr({ x: 20, y: 0 });
    startTimer();
    document.querySelector(".finish-screen").classList.remove("visible");
    pointsCounter = 0;
    counterSpan.innerHTML = pointsCounter;
    isGameOver = false;
    clearInterval(setCountdownInterval);
}

// Good old gut feeling math
const dropsPerSecond = 50 / screenWidth;
let frameCounter = 0;
const enterFrameFrequency = 200;
Crafty.bind("EnterFrame", function() {
    if (frameCounter % parseInt(enterFrameFrequency * dropsPerSecond) === 0) {
        drop();
        if (getRandomInt(0, 100) === getRandomInt(0, 100)) {
            generatePowerup();
        }
    }
    frameCounter++;
});
let powerupTimer;
function generatePowerup() {
    if (getRandomInt(0, 1) === 0) {
        const randomx = Math.floor(Math.random() * screenWidth);
        Crafty.e("Drop, 2D, Canvas, Color, Solid, Gravity, Collision, Text")
            .attr({ x: randomx, y: 0 })
            .text("x2")
            .textFont({ size: "20px", weight: "bold" })
            .gravity()
            .checkHits("Player")
            .bind("HitOn", function() {
                this.destroy();
                clearTimeout(powerupTimer);
                if (!isGameOver) {
                    player.w = playerWidth * 2;
                    powerupTimer = setTimeout(() => {
                        player.w = playerWidth;
                    }, 10000);
                }
            })
            .bind("EnterFrame", function() {
                if (this.y > screenHeight) this.destroy();
            });
    } else {
        const randomx = Math.floor(Math.random() * screenWidth);
        Crafty.e("Drop, 2D, Canvas, Color, Gravity, Collision, Text")
            .attr({ x: randomx, y: 0 })
            .text("1/2")
            .textFont({ size: "20px", weight: "bold" })
            .gravity()
            .checkHits("Player")
            .bind("HitOn", function() {
                this.destroy();
                clearTimeout(powerupTimer);
                if (!isGameOver) {
                    player.w = playerWidth / 2;
                    powerupTimer = setTimeout(() => {
                        player.w = playerWidth;
                    }, 10000);
                }
            })
            .bind("EnterFrame", function() {
                if (this.y > screenHeight) this.destroy();
            });
    }
}
